// @flow
import React, { Fragment, useEffect, useCallback, useContext } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars-2';
import isEmpty from 'ramda/es/isEmpty';
import path from 'ramda/es/path';
import toLower from 'ramda/es/toLower';

import RadioButton, { RadioButtonGroup } from 'app/common/ui/RadioButton';
import { HeaderLvl3 } from 'app/common/layouts/markup';
import { DotsLoader } from 'app/common/components/Loader';
import EmptyWarn from 'app/common/layouts/EmptyWarn';
import action from 'app/common/lib/action';

// $FlowFixMe
import { deliveryPointsFetch, SHOP_DELIVERY_POINTS_CURRENT } from 'app/common/actions/shop/order/deliveryPoints';
// $FlowFixMe
import { SHOP_SHIPPING_LOCK } from 'app/common/actions/shop/order/shipping';

import selectDeliveryPoints from './selectDeliveryPoints';
import ContextForCart from '../ContextForCart';
import DeliveryPointLabelSchool from './DeliveryPointLabelSchool';
import styles from './DeliveryPoints.module.scss';;


type DeliveryPointType = {
  id: number,
  name: string,
  phone: ?string,
  postal_code: ?string,
  state_name: ?string,
  city: ?string,
  street: ?string,
  latitude: null, // ?
  longitude: null, // ?
  is_cash_available: ?boolean,
  is_card_available: ?boolean,
  weekday_from: ?number,
  weekday_to: ?number,
  weekend_from: null, // ?
  weekend_to: null, // ?
  description: ?string,
  uuid: string,
  stock_location: {
    id: number,
    name: string,
  },
}

const DeliveryPoints = () => {
  const dispatch = useDispatch();

  const code: 'ru' | 'kz' | 'kg' = useSelector(state => toLower(state.dealer.country_iso_code), shallowEqual);

  const { availableUuids } = useContext(ContextForCart);

  const currentShippingMethod: number = useSelector(state => state.shop.order.shipping.currentShippingId, shallowEqual);

  const loadingDeliveryPoints: boolean = useSelector(state => state.shop.order.deliveryPoints.loading, shallowEqual);

  const currentDeliveryPointId: number = useSelector(state => state.shop.order.deliveryPoints.currentDeliveryPointId, shallowEqual);

  // точки доставки с учетом доступных для данного пользователя
  const deliveryPoints: Array<DeliveryPointType> = useSelector(state => selectDeliveryPoints(state, { availableUuids }), shallowEqual);

  // запрос точек доставки
  useEffect(() => {
    if (currentShippingMethod) {
      dispatch(deliveryPointsFetch(currentShippingMethod));
    }
  }, [dispatch, currentShippingMethod]);

  // установка текущей точки доставки
  useEffect(() => {
    if (!isEmpty(deliveryPoints)) {
      const firstItemId = path([0, 'id'], deliveryPoints);
      dispatch(action(SHOP_DELIVERY_POINTS_CURRENT, firstItemId));
    }
  }, [dispatch, deliveryPoints]);

  const handleChangeDeliveryPoint = useCallback((_, id) => {
    dispatch(action(SHOP_DELIVERY_POINTS_CURRENT, parseInt(id, 10)));
  }, [dispatch]);

  const nothing = !loadingDeliveryPoints && isEmpty(deliveryPoints);

  // блокирование метода доставки, если нет точек доставки у этого метода
  useEffect(() => {
    if (nothing) {
      dispatch(action(SHOP_SHIPPING_LOCK, currentShippingMethod));
    }
  }, [dispatch, nothing, currentShippingMethod]);

  return (
    <Fragment>
      {nothing
        ? <EmptyWarn className={styles.warn}>{'Пункты самовывоза не найдены'}</EmptyWarn>
        : <HeaderLvl3>
          {'Пункты самовывоза'}
          {loadingDeliveryPoints && <DotsLoader className={styles.loading} simple />}
        </HeaderLvl3>}
      {!nothing
        && <Scrollbars autoHeightMin={0} autoHeightMax={200} autoHeight>
          {/* $FlowFixMe */}
          <RadioButtonGroup
            id="select"
            className={styles.radioButtonGroup}
            valueSelected={currentDeliveryPointId}
            onChange={handleChangeDeliveryPoint}
          >
            {deliveryPoints.map(({ id, name: schoolName, phone, description }) => (
              // $FlowFixMe
              <RadioButton
                key={id}
                className={styles.radioButton}
                label={<DeliveryPointLabelSchool
                  schoolName={schoolName}
                  personName={description}
                  phone={phone}
                  code={code}
                />}
                value={id}
              />
            ))}
          </RadioButtonGroup>
        </Scrollbars>}
    </Fragment>
  );
};

export default DeliveryPoints;
